import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import GlobalNavLayout from "../../components/GlobalNavLayout";

const IdeasHubPage = lazy(() => import("../../pages/IdeasHubPage"));

export function HenriquePovedanoRoutes() {
  return (
    <Switch>
      <Route
        path="/hp/ideas-hub"
        render={() => (
          <GlobalNavLayout>
            <IdeasHubPage />
          </GlobalNavLayout>
        )}
      />
    </Switch>
  );
}

export const slug = "hp";
